module.exports = "<h4>\n  {{title}}\n</h4>\n<p>\n  {{message}}\n</p>\n<button mat-raised-button (click)=\"dialogRef.close(true)\">{{\"GENERAL.OKAY\" | translate}}</button>\n<button mat-button (click)=\"dialogRef.close(false)\">{{\"GENERAL.CANCEL\" | translate}}</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialog-confirm/dialog-confirm.component.html
// module id = ./src/app/dialog-confirm/dialog-confirm.component.html
// module chunks = main